import Swiper from 'swiper';
import { Navigation, Pagination, Mousewheel } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import './simple-carousel.pcss';
import type { ImageProps } from '@naturehouse/design-system/components/atoms/image/Image';
import type { SwiperOptions } from 'swiper/types/swiper-options';
import handleRealIndexChange from './utils/handleRealIndexChange';

export interface SimpleCarouselProps {
    slides: ImageProps[];
}

const preventClickPropagation = (event: MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();
};

const getSwiperConfig = (
    paginationElement: HTMLElement,
    nextEl: HTMLButtonElement,
    prevEl: HTMLButtonElement
): SwiperOptions => ({
    modules: [Pagination, Navigation, Mousewheel],
    pagination: {
        el: paginationElement,
        clickable: true,
        dynamicBullets: true
    },
    mousewheel: {
        forceToAxis: true
    },
    slidesPerView: 1,
    spaceBetween: 0,
    on: {
        realIndexChange: handleRealIndexChange
    },
    watchSlidesProgress: true,
    navigation: {
        nextEl,
        prevEl
    }
});

const instantiateSimpleCarousel = (): void => {
    const swiperElements = document.body.querySelectorAll<HTMLElement>(
        '[data-role="simple-carousel"]'
    );

    swiperElements.forEach((swiperEl): void => {
        const nextEl = swiperEl.querySelector('[data-role="next"]') as HTMLButtonElement;
        const prevEl = swiperEl.querySelector('[data-role="prev"]') as HTMLButtonElement;

        const paginationElement = swiperEl.querySelector(
            '[data-role="swiper-pagination"]'
        ) as HTMLElement;

        [nextEl, prevEl, paginationElement].forEach((el: HTMLElement): void => {
            el.addEventListener('click', preventClickPropagation);
        });

        const renderSwiper = (element: HTMLElement, config: SwiperOptions) =>
            new Swiper(element, config);

        renderSwiper(swiperEl, getSwiperConfig(paginationElement, nextEl, prevEl));
    });
};

export default instantiateSimpleCarousel;
